export const _translations = {
	messages: {
		en: {
			toaster: {
				more: '+{n} more',
				clearAll: 'Clear all',
			},
			buttons: {
				confirm: 'Confirm',
				cancel: 'Cancel',
			},
			multiselect: {
				projectPlaceholder: 'Select project',
			},
		},
		de: {
			toaster: {
				more: '+{n} weitere',
				clearAll: 'Alle entfernen',
			},
			buttons: {
				confirm: 'Bestätigen',
				cancel: 'Abbrechen',
			},
			multiselect: {
				projectPlaceholder: 'Projektauswahl',
			},
		},
	},
}
